import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { details } from '../../../routes/routes';
import { DetailsBackButton } from '../details-button/details-back-button';
import { DetailsCloseButton } from '../details-button/details-close-button';
import css from './details-top-buttons.module.scss';

export function DetailsTopButtons() {
  const history = useHistory();
  const background = useSelector((state) => state.router.background);
  const stack = useSelector((state) => state.router.stack);

  return (
    <Fragment>
      {stack > 1 && (
        <DetailsBackButton
          className={css.back}
          onClick={() => {
            history.goBack();
          }}
        />
      )}

      {background && <DetailsCloseButton className={css.close} onClick={() => details.close()} />}
    </Fragment>
  );
}
